import './App.css';
import SurveyorOFT from './SurveyorOFT';

function App() {
  return (
    <div className="App">
      <SurveyorOFT />
    </div>
  );
}

export default App;
